export const RouteNames = {
  Home: "/",
  SignIn: "/sign_up",
  Goals: "/goals",
  Routines: "/routines",
  NorthStar: "/northstar",
  Settings: "/settings"
};
